import { Shark, Utils, View } from "shark-mvc";

import User from "../../models/User";

import templateContent from "./user-list.html";

import mainNavComponent from "../../components/mainNav/mainNavComponent";
// import userDetailModalComponent from "../../components/userDetailModal/userDetailModalComponent";
import userManager from "../../controllers/userManager";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";

class UserListView extends View {
	route = "user-list";

	constructor () {
		super("userListView");
		this.setTemplate(templateContent);
	}

	beforeLoad () {
		window.scrollTo(0, 0);
		this.refreshList();
	}

	editUser (userGuid) {
		const { userList } = Shark.get();

		if (userList) {
			const selectedUser = Utils.safp(userList, "guid", userGuid);

			Shark.set({
				selectedUser,
			});
		}
	}

	editUserBtn_clickHandler (event, data) {
		this.editUser(data.guid);
	}

	init () {
		this.addComponents([mainNavComponent,/* userDetailModalComponent,*/ waitBoxComponent]);

		Shark.set({
			selectedUser: null,
			userList: [],
		});
	}


	inviteUser () {
		const { selectedUser } = Shark.get();

		if (selectedUser && confirm(`Confermi di voler inviare un'eMail di invito a ${selectedUser.__fullName}?\n\nSe clicchi ok non potrai annullare.`)) {
			Shark.set({__sendingInvitation: true});
			Shark.render();
			userManager.sendInvitation(selectedUser)
			.then(sendInvitationResponse => {
				console.log({sendInvitationResponse});

				if (sendInvitationResponse.data?.items?.sendResult) {
					alert(`Confermo l'invio dell'invito all'indirizzo ${sendInvitationResponse.data?.items?.receiverAddress}`);
					Shark.set({__sendingInvitation: false});
					Shark.render();
				}
			});
		}
	}

	// inviteUserBtn_clickHandler () {
	// 	this.inviteUser();
	// }

	// userBtn_clickHandler (event, data) {
	// 	const selectedUser = Utils.safp(Shark.$store.userList, "guid", data.guid);
	// 	Shark.$store.userList.forEach(item => item.__activeCSSClass = item.guid === data.guid ? "active" : "");
		
	// 	Shark.set({
	// 		activeUserGuid: data.guid,
	// 		selectedUser,
	// 	});

	// 	this.refreshDocumentList();
	// 	this.refreshPresenceEventList();

	// 	// Shark.render();
	// }

	refreshList () {
		const sorting = {
			name: "ASC",
		};
		const range = {
			first: 0,
			length: 50,
		};

		userManager.getList({sorting, range})
		.then(getListResponse => {
			if (getListResponse.data) {
				const userList = Shark.getInstanceList(User, getListResponse.data);
				
				userList.forEach((item, index) => item.__index = index);
				
				Shark.set({
					userList,
				});
				// Shark.render();
			}
		});
	}
}

const userListView = new UserListView();

Shark.registerView(userListView);

export default userListView;
